
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import personPick from '../common/personPick.vue'
import datePick from '../common/datePick.vue'
import choosePerson from '../common/choosePerson.vue'
import Agreement from '../common/Agreement.vue'
var DEBOUNCE_TIME = 400;
export default{
components:{
Group,
Cell,
XInput,
Badge,
XButton,
Icon,
personPick,
datePick,
choosePerson,
Agreement
},
data(){
return {
upvalue:'',
downvalue:'',
jsDate:'',
jsPerson:['1'],
jsPassanger:'',
defaultFlag:true,
checkBoxFlag:true,
checkBoxValue:'success',
list3:[],
personList:[[1,2,3,4,5]], //pick数据
payPrice:"",
activityName:"",
showAgree:false,
ProtocolDetail:"",
cityNo:"",
jbStorage:JSON.parse(localStorage.getItem("jbStorage")) || {},
userToken:this.$until.getUrlParam('openId') || localStorage.getItem("cdqcp_opid"),
}
},
watch:{
'checkBoxFlag':function(newValue,oldValue){
this.checkBoxValue = newValue ? 'success' : 'circle';
},
upvalue:function(newValue, oldValue){

if(this.downvalue&&this.upvalue&&(this.downvalue.id||this.downvalue.cityNo) != newValue.cityNo&& newValue){
this.$vux.toast.show({
text: "当前出发点和到达机场不在同一服务范围，请修改",
type: "text"
});
this.downvalue = "";
var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
jbStorage.downvalue = "";
jbStorage.city = "";
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
}
},
'jsDate':function(newValue,oldValue){
setTimeout(()=>{
this.callPrice()
},300);
},
downvalue:function(newValue, oldValue){
if(this.upvalue &&newValue && this.upvalue.cityNo != (newValue.id||newValue.cityNo)){
this.$vux.toast.show({
text: "当前出发点和到达机场不在同一服务范围，请修改",
type: "text"
});
this.upvalue = "";
if(window.localStorage.getItem("jbStorage")){
var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
jbStorage.mapAddress = "";
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
}else{
window.localStorage.setItem("jbStorage",{
"mapAddress":""
});
}

}


if(this.upvalue){
this.bindDateAndPerson();
}
},
'jsPerson':function(newValue,oldValue){
setTimeout(()=>{
this.callPrice()
},300);
},
jsPassanger:function(newValue, oldValue){
setTimeout(()=>{
this.callPrice();
}, 300);
},
},
methods:{
getupvalue(){
var labelflag =  1; 
if(localStorage.getItem("$currentCity") != this.upvalue.cityNo){
labelflag = 0;
}
this.$router.push("/arriveAddressB?ness=Air&from=1&label="+labelflag);
},
getdownvalue(){
if(!this.upvalue){
this.$vux.toast.show({
text: "请先设置出发地点",
type:"text"
});
return;
}
this.$router.push('/posi?back=giveawayAircraft&from=1&downvalue=1')
},
queryProtocolDetail(){
this.$http.post(window.innerAPI + "?server=queryProtocolDetail",{
code:'p_shuttle'
}).then(res =>{

this.ProtocolDetail = res.data.data.content
}).catch(err =>{
});
},
yz(val){
return this.$until.yzFontColor(val);
},//初始化时间和人数
bindDateAndPerson(cityNo){
if(this.upvalue.cityNo){
var that = this;
this.$until.getDateTime(this, this.upvalue.cityNo ,'queryAirPortConfig').then(function(data){
that.list3 = data.jspickerDate;
that.personList = [data.personList];
})
}
},

initUpValue(){

var currPoint = this.$store.state.mutations.currentPoint, that =  this, upvalue =  window.localStorage.getItem("jbStorage");

if(upvalue){
upvalue =  JSON.parse(upvalue);
if(upvalue.mapAddress){
this.upvalue =  upvalue.mapAddress;
this.upvalue.cityName = upvalue.mapAddress.cityName;

this.setdownvalue();
return;
}
}

if(currPoint){
currPoint =  currPoint.split(",");
that.setUpPoint(currPoint);
/* that.$until.checkCurrPoint(that, currPoint.join(",")).then(function (res) {

if(!res.data.data) {
that.setUpPoint(0);
return;
}
localStorage.setItem("$currentCity", res.data.data.data);


}, function (err) {
reject("请求失败");
})*/

}else{

var map =  this.$store.state.mutations.map;
var geolocation = new BMap.Geolocation();
that.$store.dispatch('showLoading');
geolocation.getCurrentPosition(function(r){
if(this.getStatus() == BMAP_STATUS_SUCCESS){
currPoint = [r.point.lng, r.point.lat];

that.setUpPoint(currPoint);
}else{
that.$store.dispatch('hideLoading'); 
that.$vux.toast.show({
text: "定位失败,请选择上车地点",
type:"text"
});
}
},{enableHighAccuracy: true})
}
},


setUpPoint(currPoint){
var geoc = new BMap.Geocoder(), that =  this;
var point = new BMap.Point(currPoint[0],currPoint[1]);

geoc.getLocation(point, function(rs){
var data =  {
point:rs.point,
address:rs.address,
"cityName":rs.addressComponents.city
}
that.setdownvalue(currPoint,data);
})
},

setdownvalue(point,data){
var jbStorage =  window.localStorage.getItem("jbStorage");
if(jbStorage){
this.downvalue = JSON.parse(jbStorage).downvalue ? JSON.parse(jbStorage).downvalue: "";
this.$store.dispatch('hideLoading'); 
return;
}
this.$http.post(window.innerAPI + "?server=initAirPort", {
"ip": "171.88.164.17",
"point":point.join(","),
"channelCode":localStorage.getItem('useCar_jb_channelCode')
}).then(res => {
if(res.data.data.code){
this.downvalue = "";
this.upvalue = "";
this.$store.dispatch('hideLoading');
return;
}
if (res.data.data) {
this.downvalue =  res.data.data;
this.upvalue = data;
this.upvalue.cityNo =  res.data.data.cityNo;

window.localStorage.setItem("jbStorage",JSON.stringify({
mapAddress: this.upvalue,
cityName: this.upvalue.cityName
}));

this.$store.dispatch('hideLoading')
var jbStorage = window.localStorage.getItem("jbStorage")
if(jbStorage){
jbStorage =  JSON.parse(jbStorage);
jbStorage.downvalue = res.data.data;
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
return;
}
window.localStorage.setItem("jbStorage",JSON.stringify({"downvalue":res.data.data}));
}
}).catch(function (errr) {

})
},
callPrice(){
if (!this.upvalue || !this.downvalue || !this.jsDate){

return;
}
this.$http.post(window.innerAPI + "?server=queryShuttlePrice",{
"bizTypeStr":"6",
"upPoint":this.upvalue.point.lat + "," + this.upvalue.point.lng,
"endSiteNo":this.downvalue.siteNo,
"numbers":this.jsPerson[0],
"useDate":this.$until.updateDate(this.jsDate),
"userToken":this.userToken,
}).then(res =>{
this.payPrice = res.data.data.data.notCarpoolPayPrice;
this.activityName = res.data.data.data.details[0].activityName;
}).catch(err =>{
});
},

submit(){
if (!this.upvalue || !this.downvalue || !this.jsDate || !this.jsPerson || !this.jsPassanger){
this.$vux.toast.show({
text:"请完善订单信息",
type:"text"
})
return;
} else if (!this.checkBoxFlag){
this.$vux.toast.show({
text:"请同意服务协议",
type:"text"
})
return;
} else {

}
var arr = [];
for(var i = 0; i < this.jsPerson; i++) {
arr.push({});
}
window.clearTimeout(this.tId);

var _p_from = this.$until.judgeBrowser();
this.tId =  setTimeout(()=>{

this.$http.post(window.innerAPI + "?server=initOrder",{
"bizType":"6",
"shiftNo":"1111",
"lineSiteEndNo": this.downvalue.siteNo,
"numbers": this.jsPerson[0],
"bookDate":this.$until.updateDate(this.jsDate).split(" ")[0],
"driverTime": this.$until.updateDate(this.jsDate).split(" ")[1],
"contactMobile": this.jsPassanger.split(" ")[1],
"contactName": this.jsPassanger.split(" ")[0],
"upAddress": this.upvalue.address,
"downAddress": this.downvalue.siteName,
"userToken":this.userToken,
"upPoint":this.upvalue.point.lat+","+this.upvalue.point.lng,
"passengersStr":JSON.stringify(arr),
"_p_from":_p_from
}).then(res=>{
if(res.data.data.code == "30000"){
this.$vux.toast.show({
text: res.data.data.errmsg,
type: "text"
});
return;
}

if(res.data.msg){
this.$vux.toast.show({
text: res.data.msg,
type: "text"
});
return;
}

if(res.data.data.code){
this.$vux.toast.show({
text: "下单失败",
type: "text"
})
return;
}
if(res.data.data){
this.$until.getBackUrl(this,res.data.data.orderNo);

}
}).catch(err=>{

});
},DEBOUNCE_TIME)


},
},
activated(){
this.downvalue = "";
this.upvalue = "";
this.payPrice = "";
this.$store.state.mutations.path = "giveawayAircraft";
this.$store.state.mutations.cityAddress =  true;
this.initUpValue()
},
mounted(){
this.payPrice = "";
this.downvalue = "";
this.upvalue = "";

this.$store.state.mutations.path = "giveawayAircraft";
this.$store.state.mutations.cityAddress =  true;
this.queryProtocolDetail()
}
}



// WEBPACK FOOTER //
// ./src/components/pickGiveAircraft/giveawayAircraft.vue